module.exports = __webpack_public_path__ + "static/media/leslie_rda.08a7ab4f.png";